import { Component, Input, OnInit, Output, EventEmitter } from "@angular/core";
import {
  latLng,
  MapOptions,
  tileLayer,
  MarkerClusterGroup,
  Map,
  Marker,
  icon,
} from "leaflet";
import { WidgetService } from "../service/widget.service";

export interface CoordinatePackage {
  latitude: number | null;
  longitude: number | null;
  location: string | null;
  extra: number | null;
}


@Component({
  selector: "app-template-map",
  templateUrl: "./template-map.component.html",
  styleUrls: ["./template-map.component.css"],
})
export class TemplateMapComponent implements OnInit {
  constructor(
    private widgetService: WidgetService
  ) { }

  @Input() coordinate_list!: any[];

  @Input() latitude!: any;
  @Input() longitude!: any;
  @Input() location!: any;
  @Input() extra!: any;


  @Input() height_value!: string;
  @Input() title!: string;
  @Input() icon!: string;
  @Input() zoom!: number;
  @Input() edit = false;

  @Output() coordinatePackageChange = new EventEmitter<CoordinatePackage>();

  map!: Map;
  mapOptions!: MapOptions;
  layersControl!: any;

  marker = new Marker([0, 0]);

  ngOnInit(): void {
    this.initializeMapOptions();
  }

  onMapReady(_map: Map) {
    this.map = _map;
    if (this.edit) {
      this.fnAddMarker(this.latitude, this.longitude, this.location);
    } else {
      this.fnAddMarkers(this.coordinate_list);
    }
  }

  onMapClick($event: any) {
    if (this.edit) {
      this.marker.setLatLng($event["latlng"]);
      this.latitude = $event["latlng"]["lat"].toFixed(6);
      this.longitude = $event["latlng"]["lng"].toFixed(6);
      this.widgetService.getAddress(this.latitude, this.longitude).subscribe(
        (x: any) => {
          const _coordinatePackage: CoordinatePackage = {
            latitude: $event["latlng"]["lat"].toFixed(6),
            longitude: $event["latlng"]["lng"].toFixed(6),
            location: x.data.address,
            extra: this.extra,
          }
          this.updateCoordinatePackage(_coordinatePackage);
        }
      )
    }
  }

  updateCoordinatePackage(value: CoordinatePackage) {
    this.coordinatePackageChange.emit(value);

  }


  private initializeMapOptions() {
    this.mapOptions = {
      layers: [
        tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
          maxZoom: 18,
          minZoom: 1,
          attribution: "Map data © OpenStreetMap contributors",
        }),
      ],

      center: latLng(0, 0),
    };
    this.layersControl = {
      baseLayers: {
        Topological: tileLayer(
          "https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png",
          {
            maxZoom: 18,
            minZoom: 1,
            attribution: "Map data © OpenStreetMap contributors",
          }
        ),
        Imagery: tileLayer(
          "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}",
          {
            maxZoom: 18,
            minZoom: 1,
            attribution: "Map data © OpenStreetMap contributors",
          }
        ),
        Outdoors: tileLayer(
          "https://{s}.tile.openstreetmap.fr/hot/{z}/{x}/{y}.png",
          {
            maxZoom: 18,
            minZoom: 1,
            attribution: "Map data © OpenStreetMap contributors",
          }
        ),







        googleStreets: tileLayer('http://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}', {
          maxZoom: 18,
          minZoom: 1,
          attribution: "Map data © OpenStreetMap contributors",
        }),

        googleHybrid: tileLayer(
          "http://{s}.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}",
          {
            maxZoom: 18,
            minZoom: 1,
            attribution: "Map data © OpenStreetMap contributors",
          }
        ),

        googleSat: tileLayer(
          "http://{s}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}",
          {
            maxZoom: 18,
            minZoom: 1,
            attribution: "Map data © OpenStreetMap contributors",
          }
        ),

        googleTerrain: tileLayer(
          "http://{s}.google.com/vt/lyrs=p&x={x}&y={y}&z={z}",
          {
            maxZoom: 18,
            minZoom: 1,
            attribution: "Map data © OpenStreetMap contributors",
          }
        ),







        None: tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
          maxZoom: 18,
          minZoom: 1,
          attribution: "Map data © OpenStreetMap contributors",
        }),
      },
    };
  }

  private fnAddMarker(_latitude: any, _longitude: any, _location: any) {
    this.marker.setIcon(
      icon({
        iconSize: [25, 41],
        iconAnchor: [13, 41],
        iconUrl: "assets/images/leaflet/marker-icon.png",
        shadowUrl: "assets/images/leaflet/marker-shadow.png",
      })
    );
    const _lat_s = ("<br/> latitude: " + _latitude) as string;
    const _lon_s = ("<br/> longitude: " + _longitude) as string;
    const _message = _location + _lat_s + _lon_s;
    this.marker.setLatLng([_latitude, _longitude]);

    this.marker.bindPopup(_message).openPopup();
    this.marker.addTo(this.map);
    this.fnSetFitBounds([{
      latitude: _latitude,
      longitude: _longitude
    }]);
    if (this.zoom) {
      this.map.setZoom(this.zoom);
    }

  }

  private fnAddMarkers(coordinate_list: any[]) {
    const markerCluster = new MarkerClusterGroup();
    coordinate_list.map((coordinate_item) => {
      const marker = new Marker([0, 0]);
      marker.setIcon(
        icon({
          iconSize: [25, 41],
          iconAnchor: [13, 41],
          iconUrl: "assets/images/leaflet/marker-icon.png",
          shadowUrl: "assets/images/leaflet/marker-shadow.png",
        })
      );

      console.log({ coordinate_item: coordinate_item });
      let _n_lat = 0.000;
      let _n_lon = 0.000;

      if (typeof coordinate_item.latitude == 'number') {
        _n_lat = coordinate_item.latitude.toFixed(6);
      } else if (typeof coordinate_item.latitude == 'string') {
        _n_lat = coordinate_item.latitude.substring(10, 0);
      }

      if (typeof coordinate_item.longitude == 'number') {
        _n_lon = coordinate_item.longitude.toFixed(6);
      } else if (typeof coordinate_item.longitude == 'string') {
        _n_lon = coordinate_item.longitude.substring(10, 0);
      }

      const _lat_s = ("<br/> latitude: " + _n_lat) as string;
      const _lon_s = ("<br/> longitude: " + _n_lon) as string;

      const _message = coordinate_item.location + _lat_s + _lon_s;
      marker.setLatLng([coordinate_item.latitude, coordinate_item.longitude]);
      marker.bindPopup(_message).openPopup();
      markerCluster.addLayer(marker);
    });
    this.map.addLayer(markerCluster);
    this.fnSetFitBounds(coordinate_list);
    if (this.zoom) {
      this.map.setZoom(this.zoom);
    }
  }

  private fnSetFitBounds(coordinate_list: any[]) {

    const _lat_min = Math.min.apply(
      null,
      coordinate_list.map((x) => x.latitude)
    );
    const _lat_max = Math.max.apply(
      null,
      coordinate_list.map((x) => x.latitude)
    );
    const _lon_min = Math.min.apply(
      null,
      coordinate_list.map((x) => x.longitude)
    );
    const _lon_max = Math.max.apply(
      null,
      coordinate_list.map((x) => x.longitude)
    );
    if (this.map)
      this.map.fitBounds([
        [_lat_min, _lon_min],
        [_lat_max, _lon_max],
      ]);
  }
}
